import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);


export function initHoverShowCase() {
  const items = gsap.utils.toArray(".card-showcase-product");

  items.forEach((item) => {

    // hover logic
    item.addEventListener("mouseenter", () => {
      items.forEach((el) => el.classList.remove("active"));
      item.classList.add("active");
    });

    const target = item.querySelector(".card-showcase-product__item");
    const media = item.querySelector(".card-showcase-product__background");
    const content = item.querySelector(".card-showcase-product__content");

    if (target && content) {

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: item,
          start: "top center",
          end: "bottom top",
          anticipatePin: 1
        }
      });

      tl.from(media, {
          opacity: 0,
          duration: 0.1
        }, "<")
        .from(target, {
          y: "-50%",
          opacity: 0,
          duration: 0.6
        })
        .from(content, {
          y: "30%",
          opacity: 0,
          duration: 0.6
        }, "<")
    }

  });
}